export const GET_LOCATIONS_BEGIN = 'get_locations_begin';
export const GET_LOCATIONS_REQUESTING = 'get_locations_requesting';
export const GET_LOCATIONS_SUCCESS = 'get_locations_success';
export const GET_LOCATIONS_ERROR = 'get_locations_error';

export const GET_LOCATION_BEGIN = 'get_location_begin';
export const GET_LOCATION_REQUESTING = 'get_location_requesting';
export const GET_LOCATION_SUCCESS = 'get_location_success';
export const GET_LOCATION_ERROR = 'get_location_error';
export const GET_LOCATION_RESET = 'get_location_reset';

export const SET_LOCATION_BEGIN = 'set_location_begin';
export const SET_LOCATION_REQUESTING = 'set_location_requesting';
export const SET_LOCATION_SUCCESS = 'set_location_success';
export const SET_LOCATION_ERROR = 'set_location_error';
export const SET_LOCATION_RESET = 'set_location_reset';

export const UPDATE_LOCATION_BEGIN = 'update_location_begin';
export const UPDATE_LOCATION_REQUESTING = 'update_location_requesting';
export const UPDATE_LOCATION_SUCCESS = 'update_location_success';
export const UPDATE_LOCATION_ERROR = 'update_location_error';
export const UPDATE_LOCATION_RESET = 'update_location_reset';

export const DELETE_LOCATION_BEGIN = 'delete_location_begin';
export const DELETE_LOCATION_REQUESTING = 'delete_location_requesting';
export const DELETE_LOCATION_SUCCESS = 'delete_location_success';
export const DELETE_LOCATION_ERROR = 'delete_location_error';
export const DELETE_LOCATION_RESET = 'delete_location_reset';